import React from 'react';
import { useSelector } from 'react-redux';
import { Surface } from '@vst/beam';

import { selectStreamOnPromo } from '@app/redux/streamOnPromo';

import { Address as IRAAddress } from '@mfe/shared/schema-types';

import { EditAddress, EditAddressProps } from '../EditAddress';
import { StaticAddress } from '../StaticAddress';

interface AddressProps extends EditAddressProps {
  address: IRAAddress;
}

export const Address = ({ address, onSubmit, onCancel }: AddressProps) => {
  const { isEditingAddress } = useSelector(selectStreamOnPromo);
  return (
    <Surface variant="primary" radius="16px" theme="light">
      {isEditingAddress ? <EditAddress onSubmit={onSubmit} onCancel={onCancel} /> : <StaticAddress address={address} />}
    </Surface>
  );
};

export default Address;
